import { useState, useMemo, useEffect } from "react";
import { authService } from "../dependencyInjection";
import { RequestStatus } from "../../shared";
import { unsubscribe } from "../../../../utils";
import { User } from "../services/AuthService"; // TODO: Перенести в модели

export type UseRegistration = (user: User) => Promise<void>;

export function useRegistration(): [RequestStatus, UseRegistration] {
  const [status, setStatus] = useState(RequestStatus.None);
  const registration: UseRegistration = useMemo(
    () => async (user) => {
      setStatus(RequestStatus.Pending);
      try {
        await authService.registration(user);
      } catch (err) {}
    },
    [],
  );

  useEffect(() => {
    const sub = authService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(sub);
  }, []);

  return [status, registration];
}
